/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-unresolved */
/* eslint-disable max-len */
import { Redirect, Route } from 'react-router-dom';

import { isAuthenticatedVar } from 'Apollo/config';
import { ModuleIdEnum } from 'constants';
import UnAuthorized from 'views/Shared/components/UnAuthorized';
import { getAllowedModule, isAuthenticated } from '../views/Auth/AuthHelper';

const allowedRoutesBasedOnModule = {
    [ModuleIdEnum.DATARECONCILIATION]: ['/data-recon-home', '/projects', '/data-lineage-upload', '/dataconfiguration', '/relations', '/data-quality', '/quality-details', '/datareconciliationstatus', '/datareconresult'],
    [ModuleIdEnum.RULEENGINE]: ['/UploadReport', '/fry7q', '/fyresults', '/metro2', '/metro2Result', '/FFIEC009', '/FFIEC009Result', '/fr2052a', '/fr2052aResult', '/fry9c', '/fry9cresults', '/ffiec031', '/ffiec031results', '/ffiec041', '/ffiec041results', '/Remediation'],
    [ModuleIdEnum.CROSSREPORTVALIDATION]: ['/cross-report'],
    [ModuleIdEnum.TRENDANALYTICS]: ['/analytics'],
};

const ProtectedModuleRoute = ({ component: Component, ...restOfProps }) => {
    const moduleIds = getAllowedModule();
    const loggedIn = isAuthenticated();
    isAuthenticatedVar(loggedIn);
    return (
        <Route
            {...restOfProps}
            render={props => {
                if (loggedIn) {
                    let module;
                    Object.keys(allowedRoutesBasedOnModule).forEach(k => {
                        if (allowedRoutesBasedOnModule[k].includes(restOfProps.path)) {
                            module = k;
                        }
                    });
                    if (moduleIds && moduleIds.includes(Number(module))) {
                        return <Component {...props} />;
                    }
                    return <UnAuthorized />;
                }
                return <Redirect to="/login" />;
            }}
        />
    );
};

export default ProtectedModuleRoute;
